<template>
  <section>
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            お支払い方法をお選びください。
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-invoice">
            <h3 class="subtitle">請求書払</h3>
            <p>請求書払の場合は毎月5日にメールで請求書が発行されます。メール添付の請求書にお振込先の口座が記載されています。</p>
            <p style="margin-top: 30px;"></p>
            <a class="button is-primary is-rounded" style="font-size:13px;">請求書払を選択</a>
          </div>
          <div class="box-credit">
            <h3 class="subtitle">クレジットカード払</h3>
            <p>請求書払の場合は毎月XX日に自動で指定されたクレジットカードから自動で引き落としを行います。</p>
            <p style="margin-top: 30px;"></p>
            <form action="/dashboard/setting/plan" method="post" id="payment-form">
              <div class="form-row">
                <label for="card-element">
                  カード番号を入力
                </label>
                <div id="card-element">
                  <!-- A Stripe Element will be inserted here. -->
                </div>
                <!-- Used to display form errors. -->
                <div id="card-errors" role="alert"></div>
              </div>
              <button class="button is-primary is-rounded" style="margin-top:10px; font-size:13px;">カード払を選択</button>
            </form>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalSelectBilling',
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('setting', ['isModalSelectBilling'])
  },
  data () {
    return {
      isModal: false
    }
  },
  watch: {
    isModalSelectBilling: function () {
      this.isModal = this.isModalSelectBilling
    },
    isModal: function () {
      this.isModal ? console.log('isModal: true') : this.modalSelectBilling()
    }
  },
  methods: {
    modalSelectBilling () {
      console.debug('*** Start *** modalSelectBilling')
      this.$store.dispatch('setting/modalSelectBilling')
      console.debug('*** End *** modalSelectBilling')
    }
  },
  updated () {
    console.debug('*** Start *** updated')
    // Create a Stripe client.
    // process.envに変えること
    var stripe = Stripe('pk_test_DU9Ei3EjEGRonmCxsWur1hs5') // eslint-disable-line
    // Create an instance of Elements.
    var elements = stripe.elements()
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '12px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }
    console.info('style: ' + style)
    // Create an instance of the card Element.
    var card = elements.create('card', {style: style})
    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element')
    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', function (event) {
      var displayError = document.getElementById('card-errors')
      if (event.error) {
        console.error('error: ' + event.error.message)
        displayError.textContent = event.error.message
      } else {
        console.info('event not error')
        displayError.textContent = ''
      }
    })
    // Handle form submission.
    var vm = this
    var form = document.getElementById('payment-form')
    form.addEventListener('submit', function (event) {
      event.preventDefault()
      stripe.createToken(card).then(function (result) {
        if (result.error) {
          console.error('error: ' + result.error.message)
          // Inform the user if there was an error.
          var errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
        } else {
          console.info('event not error')
          // Send the token to your server.
          console.log(JSON.stringify(result.token))
          vm.$store.dispatch('setting/billingSave', {data: result.token, email: vm.user.companyEmail})
            .then(() => {
              vm.$buefy.toast.open({
                message: 'クレジットカードの登録が完了しました。領収書はメールをご確認ください。',
                type: 'is-success'
              })
              setTimeout(location.reload(), 900)
            })
        }
      })
    })
    console.debug('*** End *** updated')
  }
}
</script>

<style scoped>
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.subtitle {
  font-size: 20px;
  font-weight: 700;
}
.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 40px;
}
.box-invoice {
  width: 270px;
  height: 350px;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.box-credit {
  width: 270px;
  height: 350px;
  border-left: solid thin #ccc;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalSelectBilling.vue